import React, { Component } from 'react';
import { Provider } from 'react-redux'
import { connect } from 'react-redux';
import { Store } from 'redux'

//import 'office-ui-fabric-react/dist/css/fabric.css';

import 'bootstrap/dist/css/bootstrap.css';
import { ApplicationState } from './store'
// @ts-ignore
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'

import Template from './template';

// // Any additional component props go here.
// interface MainProps {
//   store: Store<ApplicationState>
// }

// // Create an intersection type of the component props and our Redux props.
// const App: React.FC<MainProps> = ({ store }) => {

//   return (
//     <Provider store={store}>
//       <ReactNotification
//         types={[
//           {
//             htmlClasses: ['notification-awesome'],
//             name: 'awesome'
//           }
//         ]}
//         isMobile={true}
//       />
//       <Template />
//     </Provider>
//   )
// }

// export default App


interface PropsFromState {
  store: Store<ApplicationState>
}
interface IState {
}
interface PropsFromDispatch {
}
type AllProps = PropsFromState & PropsFromDispatch

class App extends Component<AllProps, IState> {
  constructor(props: AllProps) {
    super(props);
    this.handleWindowBeforeUnload.bind(this);
  }
  
  componentDidMount() {
      window.addEventListener("beforeunload", this.handleWindowBeforeUnload);
  }

  componentWillMount() {
      window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);
  }
  
  handleWindowBeforeUnload(event:any){
    //event.preventDefault();
    //alert('Form unload!');
    //event.returnValue = `Are you sure you want to leave?`;
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <ReactNotification 
          isMobile={true}
        />
        <Template />
      </Provider>
    )
  };
}

const mapStateToProps = (state: ApplicationState) => ({   })
const mapDispatchToProps = {  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);
